import {BasicClient} from '@/utils/httpClient';
import { object } from 'underscore';

export default class Actions {
  client: BasicClient;
  constructor(){
    this.client = new BasicClient();
  }
  getActions(needUpdate = false):any{
    let cachedData = localStorage.getItem('actions');
    if (cachedData && !needUpdate) {
     
      cachedData = JSON.parse(cachedData);
        return Promise.resolve(cachedData);
      }
    
    else {
    return this.client.exec('/actions/available', 'GET')
      .then(response => {
        localStorage.setItem('actions', JSON.stringify( response));
        return Promise.resolve(response);
      })
      .catch(error => {
        return Promise.reject(error);
      });}
    
  }

  setActionSelfService(params) {
    return this.client.exec('/v2/actions/self-service', 'POST', params);
  }

  removeActionSelfService(params) {
    return this.client.delete('/v2/actions/self-service', params);
  }

  getActionsSelfService() {
    return this.client.exec('/v2/actions/self-service', 'GET');
  }
}